import app from "flarum/forum/app";
import StoreItemUtils from "../utils/StoreItemUtils";
import QueryModal from "../components/QueryModal";
export class UseHelper {
  constructor(purchaseHistory) {
    this.purchaseHistory = purchaseHistory;
  }
  static async get(provider) {
    return new UseHelper(await app.store.find("purchase-history", {
      type: provider
    }));
  }
  filter(predicate) {
    this.purchaseHistory = this.purchaseHistory.filter(predicate);
    return this;
  }
  filterWithData(predicate) {
    this.purchaseHistory = this.purchaseHistory.filter(d => predicate(d.attribute("data")));
    return this;
  }
  filterAvailable() {
    return this.filter(d => {
      return !d.unavailable() && d.rest_cnt() > 0;
    });
  }
  expireTimeRev() {
    this.purchaseHistory.sort((a, b) => {
      if (a.expire_at() === null) {
        if (b.expire_at() === null) return 0;else return 1;
      }
      return new Date(a.expire_at()).getTime() > new Date(b.expire_at()).getTime() ? 1 : -1;
    });
    return this;
  }
  expireTime() {
    this.purchaseHistory.sort((a, b) => {
      if (a.expire_at() === null) {
        if (b.expire_at() === null) return 0;else return -1;
      }
      return new Date(a.expire_at()).getTime() > new Date(b.expire_at()).getTime() ? -1 : 1;
    });
    return this;
  }
  sort(predicate) {
    this.purchaseHistory.sort(predicate);
    return this;
  }
  query() {
    return new Promise((resolve, reject) => {
      if (!this.purchaseHistory.length) return resolve(this);
      const items = this.purchaseHistory;
      this.purchaseHistory = [];
      app.modal.show(QueryModal, {
        items,
        on_submit: selected => {
          this.purchaseHistory = [selected];
        },
        on_close: () => {
          resolve(this);
        }
      }, true);
    });
  }
  hasItem() {
    return this.purchaseHistory.length > 0;
  }
  async use(data) {
    if (!this.purchaseHistory.length) {
      throw new Error("no_item_to_use");
    }
    return await StoreItemUtils.getInstance().useWithData(this.purchaseHistory[0], data);
  }
}
flarum.reg.add('xypp-store', 'forum/helper/UseHelper', { UseHelper: UseHelper, });